import { render, staticRenderFns } from "./DataCorrectionTaskQueueLevel2.vue?vue&type=template&id=7d3c3922&scoped=true&"
import script from "./DataCorrectionTaskQueueLevel2.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionTaskQueueLevel2.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionTaskQueueLevel2.vue?vue&type=style&index=0&id=7d3c3922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3c3922",
  null
  
)

export default component.exports